<template>
  <div class="dialogGroup_cont">
    <div class="dialogGroup_left no_group">
      <ly-tree
        :gpno="areaId"
        :is_superuser="false"
        :area-tree-type="2"
        :showcount="true"
        :displaynoarea="true"
        @treeClick="treeClick"
      />
    </div>

    <div class="dialogGroup_right">
      <div class="Group_right_header">
        <div class="blue_header">
          <span>{{ $t('scene.sceneSelect') }}
            <template>
              （<em>{{ allcardNum }}</em>）
            </template>
          </span>
        </div>

        <customer-select :value="sortTianmuValue" class="tianmu-sort" @change="sortTianmuChange" />
        <sort-select :value="sortType" @change="sortTypeChange" />
        <el-divider direction="vertical" />
        <div class="search_way">
          <div class="search_mt">
            <el-input
              v-model="infoSearch"
              :placeholder="$t('scene.searchPlhode1')"
              size="medium"
              @keyup.enter.native="doSearchlist"
            />
            <el-button
              class="search_button"
              icon="el-icon-search"
              type="text"
              @click="doSearchlist"
            />
          </div>
        </div>

        <div class="ok_group de_ok_group">
          <template v-if="okCheckNum > 0">
            <el-badge :value="okCheckNum" class="item">
              <button @click="createGrop">
                {{ computedNextText }}
              </button>
            </el-badge>
          </template>
          <template v-else>
            <button @click="createGrop">
              {{ computedNextText }}
            </button>
          </template>
        </div>
      </div>
      <div class="right_card_box">
        <vuescroll>
          <div v-loading="loading">
            <v-scence
              :show-report="true"
              :scence-card="cardlist"
              :is_check="true"
              :isradio="isradio"
              :nocall="nocall"
              :require-max-sence="requireMaxSence"
              :max-sence="maxSence"
              :has-select-sence="hasSelectSence"
              @showReportEvent="showReportEvent"
              @removeTree="removeTree"
            />
          </div>
        </vuescroll>
      </div>
    </div>
    <template v-if="is_sceneActionReport">
      <div class="dialogMask" @click.stop="is_sceneActionReport = false">
        <div
          class="remove_tree slelectModifyBody"
          :style="'width:auto;height:auto;position: absolute;margin: 0;left:' + sceneActionReportPointX + 'px;top:' + sceneActionReportPointY + 'px;'"
        >
          <v-scenceactionreport :scence-info="scenceInfo" @handleCloseSceneActionReport="handleCloseSceneActionReport" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import vuescroll from 'vuescroll'
import vScence from '@/components/common/scenceMode.vue'
import vScenceactionreport from '@/components/common/sceneActionReport.vue'
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js'
import { FindSceneList,FindSceneListByPage } from '@/axios/IScene.js'
import SortSelect from '@/components/select/SortSelect'
import CustomerSelect from '@/components/select/CustomerSelect'

import { getSortType } from '@utils/utils'
export default {
  components: {
    vuescroll,
    vScence,
    vScenceactionreport,
    SortSelect,
    CustomerSelect
  },
  props: {
    //通过props接收父组件传值
    areaid: {
      type: Number,
      default: -1,
    },
    // 确认按钮文案
    nextText: {
      type: String,
      default: '',
    },
    isradio: {
      type: Boolean,
      default: false,
    },
    nocall: {
      type: Boolean,
      default: false,
    },
    alreadyCheck: {
      type: Array,
      default() {
        return []
      },
    },
    // 打开的类型, 'copy': 复制场景
    openType: {
      type: String,
      default: '',
    },
    //是否过滤已经选中的场景
    filterAlreadyCheck: {
      type: Boolean,
      default: false,
    },
    //是否支持最大场景数逻辑判断
    requireMaxSence: {
      type: Boolean,
      default: false,
    },
    //最大场景数
    maxSence: {
      type: Number,
      default: 0,
    },
    //已经选择了的场景数
    hasSelectSence: {
      type: Number,
      default: 0,
    },

  },
  data() {
    return {
      areaId: this.areaid,
      infoSearch: '',
      sortType: getSortType(),
      CheckedData: [], //选中的场景id
      loading: false, //是否加载中
      okCheckNum: 0, //选中的数量
      allcardNum: 0, //总数量
      checkblock: true, //未使用
      nextvalue: this.$t('scene.yes'), //确定文字描述
      //  nextvalue:this.$t('scene.yes'), //确定文字描述
      // cardlist:[{},{},{},{},{},{},{},{},{},{}],
      cardlist: [], //数据容器
      is_sceneActionReport: true,
      sceneActionReportPointX: 400, //修改设备名称选标签窗口坐标X
      sceneActionReportPointY: 100, //修改设备名称选标签窗口坐标Y
      // sceneActionReportWidth: 250, //修改设备名称选标签窗口宽度
      // sceneActionReportHeight: 320, //修改设备名称选标签窗口高度
      scenceInfo: null,
      sortTianmuValue:0
    }
  },

  computed: {
    // 确定文字描述
    computedNextText() {
      return this.nextText || this.$t('scene.yes')
    },
  },
  created() {},
  mounted() {
    this.is_sceneActionReport = false
    this.doFindSceneList(this.areaId)
  },
  methods: {
    sortTianmuChange(e){
      this.sortTianmuValue = e
      this.doFindSceneList(this.areaId)
    },
    doSearchlist() {
      this.pageIndex = 1
      this.doFindSceneList(this.areaId)
    },
    sortTypeChange(v) {
      this.sortType = v
      this.pageIndex = 1
      this.doFindSceneList(this.areaId)
    },
    showReportEvent(param) {
      this.is_sceneActionReport = true
      this.scenceInfo = param[0]
    },
    handleCloseSceneActionReport() {
      this.is_sceneActionReport = false
    },
    /* 获得选择的数据
     */
    getCheckedData() {
      //获得选择的数据
      var _arry = []
      this.cardlist.forEach(item => {
        if (item.ischecked) {
          _arry.push(item)
        }
      })
      this.CheckedData = _arry
      this.okCheckNum = this.CheckedData.length
      _arry = null
    },
    /* 点击选中卡片
     * var: 点击的对象
     */
    removeTree(val) {
      this.cardlist = val[0]
      this.getCheckedData()
    },
    /* 获得场景数据 接口返回处理
     * rs: 接口返回的数据包
     */
    functionDoFindSceneList(rs) {
      this.loading = false
      this.cardlist = []
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result && rs.Result.RecordList && Array.isArray(rs.Result.RecordList)) {
          rs.Result.RecordList.forEach(item => {
            var isdel = false
            let hasAlreadyCheck = false
            for (let i = 0; i < this.alreadyCheck.length; i++) {
              if (item.SceneNo == this.alreadyCheck[i].SceneNo) {
                hasAlreadyCheck = true
              }
              if (this.alreadyCheck[i].ActionType == 4) {
                if (item.SceneNo == this.alreadyCheck[i].SceneNo) {
                  isdel = true
				  break
                }
              }
            }
            item.havecheck = isdel //是否已选
            item.flag = false //是否可编辑
            item.ischecked = false //是否默认选中
			console.log('......//过滤选中的场景')
			if(this.filterAlreadyCheck && hasAlreadyCheck) {
				//过滤选中的场景
			}else{
			  this.cardlist.push(item)
			}
           
          })
        } else {
          this.cardlist = []
        }
        this.allcardNum = this.cardlist.length
      }
    },
    /* 搜索场景列表
     * _gpno: 区域号
     */
    doFindSceneList(_gpno) {
      //搜索场景列表
      console.log('...搜索场景列表')
      
        this.loading = true
        var para = { gpNo: _gpno, loadMode: 0, sceneName: this.infoSearch,pageSize:9999,filterType:this.sortTianmuValue }
        if (this.sortType !== '') {
          para.sortMode = this.sortType
        }
        FindSceneListByPage(para, this.functionDoFindSceneList)
        para = null
      
    },
    /* 点击树搜索
     * val: 区域号
     */
    treeClick(val) {
      this.areaId = val[0].id
      this.doFindSceneList(val[0].id)
    },
    /* 选中 点击确定 将选中的数据 传值给调用页面
     */
    createGrop() {
      if (this.CheckedData.length > 0) {
        this.$emit('confirm', this.CheckedData)
      } else {
        warning(this, this.$t('scene.selectScence'))
      }
    },
  },
}
</script>

<style scoped="scoped" lang="scss">
/* 场景模式选择组件	 */
.refresh {
  right: 0px;
}
.dialogGroup_right {
  .blue_header {
    margin-right: 45px;
  }
  .el-divider {
    margin: 0 43px;
    height: 3em;
  }
}
.search_way {
  float: none;
  width: 190px;
  margin-top: 0;
}
.tianmu-sort{
  margin-right: 10px;
}
</style>
